import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import AppBar from '@material-ui/core/AppBar';
import Avatar from '@material-ui/core/Avatar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import {Dropdown, DropdownMenu, DropdownToggle} from 'reactstrap';
import Drawer from '@material-ui/core/Drawer';
import {
  BELOW_THE_HEADER,
  COLLAPSED_DRAWER,
  FIXED_DRAWER,
  HORIZONTAL_NAVIGATION,
  INSIDE_THE_HEADER
} from '../../constants/ActionTypes';

import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/Inbox';

import {switchLanguage, toggleCollapsedNav} from '../../actions/Setting';
import IntlMessages from '../../../external/util/IntlMessages';

import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { runtime, createIcon } from '../../../common';
import App from '../../containers/App';
import AppsIcon from '@material-ui/icons/Apps';
import Modal from 'codeArt/components/Modal';
import SearchBox from 'components/SearchBox';
import { Link as CoreLink } from '@material-ui/core';

class Header extends React.Component {

  onAppNotificationSelect = () => {
    this.setState({
      appNotification: !this.state.appNotification
    })
  };
  onMailNotificationSelect = () => {
    this.setState({
      mailNotification: !this.state.mailNotification
    })
  };
  onLangSwitcherSelect = (event) => {
    this.setState({
      langSwitcher: !this.state.langSwitcher, anchorEl: event.currentTarget
    })
  };
  onSearchBoxSelect = () => {
    this.setState({
      searchBox: !this.state.searchBox
    })
  };
  onAppsSelect = () => {
    this.setState({
      apps: !this.state.apps
    })
  };
  onUserInfoSelect = () => {
    this.setState({
      userInfo: !this.state.userInfo
    })
  };
  handleRequestClose = () => {
    this.setState({
      langSwitcher: false,
      userInfo: false,
      mailNotification: false,
      appNotification: false,
      searchBox: false,
      apps: false
    });
  };
  onToggleCollapsedNav = (e) => {
    const val = !this.props.navCollapsed;
    this.props.toggleCollapsedNav(val);
  };

  toggleDrawer = (open) => {
    if(open === this.state.drawer) return;
    this.setState({drawer: open});
  };

  constructor() {
    super();
    this.state = {
      anchorEl: undefined,
      searchBox: false,
      searchText: '',
      mailNotification: false,
      userInfo: false,
      langSwitcher: false,
      appNotification: false,
      drawer:false
    }
  }

  updateSearchText(evt) {
    this.setState({
      searchText: evt.target.value,
    });
  }
  
  
  back(){
    App.current.back();
  }

  mobileLeft(drawerStyle,back){
    //if(runtime.pc) return null;
    return back?<IconButton className={`jr-menu-icon mr-1 mr-sm-3 p-0 ${drawerStyle}`} aria-label="Back" onClick={()=>{ this.back(); }} style={{marginLeft:-5}}>
                  <ArrowBackIcon className="p-0 m-0 c-icon-s3 text-white" />
              </IconButton>:
            <IconButton className={`jr-menu-icon mr-1 mr-sm-3 ${drawerStyle}`} aria-label="Menu" onClick={this.onToggleCollapsedNav}>
                <span className="menu-icon"/>
            </IconButton>;
  }

  renderNotifications(){
    let {quick,toolbar}=this.props;
    if(!quick && !toolbar) return null;
    return (
      <ul className="header-notifications list-inline ml-auto">
        {this.renderQuick()}
        {this.renderToolbar()}
      </ul>
    );
  }


  renderQuick(){
    let {quick}=this.props;
    if(!quick) return;
    let {items}=quick;
    items = items||[];
    return (<li className="list-inline-item">
      <Dropdown
        className="quick-menu app-notification c-header-dropdown"
        isOpen={this.state.apps}
        toggle={this.onAppsSelect.bind(this)}>
        <DropdownToggle
          className="d-inline-block"
          tag="span"
          data-toggle="dropdown">
          <span className="app-notification-menu">
            <i className="zmdi zmdi-star c-icon-s1"/>
            <span className="c-text-s1">{quick.title}</span>
          </span>
        </DropdownToggle>
        {
          items.length>0?
          <DropdownMenu className="shadow-sm c-px-0 c-radius2">
          <ul className="jr-list c-py-trim">
            {items.map(({label,active,onClick},index)=>{
              return (
                <li key={index} className="w-100 c-py-0d5">
                  <CoreLink key={index} className={`jr-list-link py-1 c-pointer mx-2 c-radius2 ${active?'c-light-primary-selected c-jr-list-link-active':'c-light-primary-hover'}`} onClick={()=>{ onClick(); }}>
                    <span className="jr-list-text c-text-s1 text-nowrap">{label}</span>
                  </CoreLink>
                </li>
              )
            })}
          </ul>
        </DropdownMenu>:null
        }
        
      </Dropdown>
    </li>);
  }

  renderToolbar(){
    let {toolbar}=this.props;
    toolbar = toolbar||[];
    return toolbar.map((item,index) => {
      return item?(<li key={`toolbar-${index}`} className="list-inline-item">
        {item}
      </li>):null;
    });
  }

  render() {
    const {drawerType, locale, navigationStyle, horizontalNavPosition,header,config} = this.props;
    const drawerStyle = drawerType.includes(FIXED_DRAWER) ? 'd-block d-xl-none' : drawerType.includes(COLLAPSED_DRAWER) ? 'd-block' : 'd-none';
    
    let { title, subtitle, back } = header || {};
    return (
      <AppBar key={0} elevation={runtime.pc?4:1} 
        className={`app-main-header ${(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === BELOW_THE_HEADER) ? 'app-main-header-top' : ''}`}>
        <Toolbar className="app-toolbar" disableGutters={false}>
          {navigationStyle === HORIZONTAL_NAVIGATION ?
            <div className="d-block d-md-none pointer mr-3" onClick={this.onToggleCollapsedNav}>
                            <span className="jr-menu-icon">
                              <span className="menu-icon"/>
                            </span>
            </div>
            :
           this.mobileLeft(drawerStyle,back)
          }

          <Link className="app-logo mr-2 d-sm-block" to="/">
            <img src={require("../../assets/images/logo.png")} alt="易视维科技" title="易视维科技"/>
          </Link>


            {/* <div className="c-app-mobile-header d-mo-flex w-100 h-100 justify-content-between align-items-center">
              <p className="mb-0 text-dark c-text-s3">{title}</p>
            </div> */}

          {this.renderNotifications()}
          <div className="ellipse-shape"></div>
        </Toolbar>
      </AppBar>
    );
  }


}


const mapStateToProps = ({settings}) => {
  const {drawerType, locale, navigationStyle, horizontalNavPosition,header} = settings;
  return {drawerType, locale, navigationStyle, horizontalNavPosition,header}
};

export default withRouter(connect(mapStateToProps, {toggleCollapsedNav, switchLanguage})(Header));

